import { type FeatureModule } from '@/components/routing';

/** Routes and nav entries of the `chargers` feature. */
export const chargersFeature: FeatureModule = {
  id: 'chargers',
  routes: [
    {
      path: 'chargers',
      lazy: async () => ({ Component: (await import('./pages/chargers-page')).ChargersPage }),
    },
  ],
  navItems: [{ to: '/chargers', ns: 'chargers', labelKey: 'nav.chargers', icon: 'link', order: 20 }],
};
